import React from 'react'
import './portfolio.css'
import IMG1 from  '../../assets/portfolio1.png'
import IMG2 from  '../../assets/portfolio2.jpg'
import IMG3 from  '../../assets/portfolio3.jpg'
import IMG4 from  '../../assets/portfolio4.jpg'
import IMG5 from  '../../assets/portfolio5.png'
import IMG6 from  '../../assets/portfolio6.jpg'

const data =[
{
  id: 1,
  Image: IMG1,
  title: 'Markpaul-weatherApp',
  github:'https://github.com/maqiie/weather-appgit',
  demo:'https://markpaul-weatherapp.netlify.app'
},
{
  id: 2,
  Image: IMG2,
  title: 'Moringa_pair an app that randomly pairs students and keeps track of them',
  github:'https://github.com/',
  demo:'https://moringa-pair.vercel.app/it'
},
{
  id: 3,
  Image: IMG3,
  title: 'E-Portfolio website',
  github:'https://github.com/',
  demo:'https://markpaul.netlify.app/'
},
{
  id: 4,
  Image: IMG4,
  title: 'Bakery shop',
  github:'https://github.com/',
  demo:'https://intreats.vercel.app/'
},
{
  id: 5,
  Image: IMG5,
  title: 'iBlog is an app that lets you share  you most intresting stories and blogs that inspire others',
  github:'https://github.com/',
  demo:'https://ibl0g.vercel.app/' 
},
{
  id: 6,
  Image: IMG6,
  title: 'Charts template & infogramics in Figma',
  github:'https://github.com/',
  demo:'https://dribbble.com/shots/16580766-Orion-UI-kit-charts-templates-infographics-in-figma'
},


]




const portfolio = () => {
  return (
    <section id='portfolio'> 
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">

        {
          data.map(({id, Image, title, github, demo})=>{
            return(
                <article key={id} className='portfolio__item'>
                   <div className='portfolio__item-image'>
                     <img src={Image} alt={title} />
                   </div>
                  <h3>{title}</h3>
                <div className="portfolio__item-cta">
                   <a href={github} className='btn' target='_blank'>Github</a>
                   <a href={demo} target='_blank' className='btn btn-primary'>Live Demo</a>
                </div>
            </article>
            )
          })
        }

      </div>

    </section>
  )
}

export default portfolio
